import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router";
import { MantineReactTable } from "mantine-react-table";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InfinitySpin } from "react-loader-spinner";
import { endpoints } from "../../../../services/apiurl";
import { Card, Button } from "@mui/material";
import Input from "../../../UI/Input/Input";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import PageTitle from "../../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";

const getItems = (ii) =>
  Array.from({ length: ii.length }, (v, k) => k).map((k) => ({
    id: `${ii[k].id}`,
    name: ii[k].name,
    status: `${ii[k].status}`,
    // last: ii[k].id,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

//console.log(localStorage.getItem("user"));

class RestCategoryDetail extends Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      data: [],
      number: 1,
      name: "",
      status: "",
      section_id: '',
      rowCount: 0,
      restro_id: localStorage.getItem("restro_id"),
      pagination: {
        pageIndex: 0,
        pageSize: 10,
      },
      currentPage: 1,
      page: 1,
      per_page: 20,
      totalPages: 1,
      restro_id: this.props.match.params.restro_id,
    };
    // console.log(this.state.currentPage)

    this.section_id = this.props.match.params.restro_id;
    this.rest_id = this.props.match.params.rest_id;

    // console.log(this.section_id);
    // console.log(this.state.restro_id);
    localStorage.setItem("section_id", this.section_id);
    this.bFilter1 = this.bFilter1.bind(this);

  }

  componentDidMount() {
    const { location } = this.props;
    if (location.search != "") {
      const urlParams = new URLSearchParams(window.location.search);
      //console.log(urlParams, "urlParams");

      const filter2Param = urlParams.get("filter2");
      //console.log("incp", filter2Param);

      if (filter2Param) {
        this.name = filter2Param;
        this.bFilter1();
      }
    } else {
      // console.log(location, "hhjj");
      // this.fetchData();
      const currentPage = sessionStorage.getItem('currentPage');
      if (currentPage) {
        this.setState({ currentPage: parseInt(currentPage) }, () => {
          this.fetchData();
        });
      } else {
        this.fetchData();
      }
    }
  }

  bFilter1 = async () => {
    // console.log(this.name);
    var name = this.name;
    var section_id = this.section_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.categoryFilter, {
        page,
        per_page,
        name,
        section_id,
      })
      .then((response) => {
        // window.location.reload(true);
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          DataisLoaded: true,
        });
        //console.log(response.data);
      });
  };

  fetchData() {
    const { restro_id, currentPage, per_page } = this.state;

    axios
      .post(endpoints.getCategory, {
        page: currentPage,
        per_page,
        restro_id,
      })
      .then((response) => {
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          DataisLoaded: true,
          rowCount: response.data.total,
        });
      });
  }

  bFilter() {
    const { name, section_id, page, per_page, status } = this.state;

    axios
      .post(endpoints.categoryFilter, {
        page: page,
        per_page,
        name,
        status,
        section_id: this.section_id
      })
      .then((response) => {
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem('data', JSON.stringify(response.data.data)),
          DataisLoaded: true,
        });
      });
  }

  onNameChange = (e) => {
    this.setState({ name: e.target.value }, () => {
      this.bFilter();
    });
  };

  onStatusChange = (e) => {
    this.setState({ status: e.target.value }, () => {
      this.bFilter();
    });
  };

  handleResetFilters = () => {
    this.setState({ name: '', status: '' }, () => {
      this.setState(
        { currentPage: 1, pagination: { pageIndex: 0, pageSize: 10 } },
        () => {
          this.fetchData();
        }
      );
    });
  };


  move = (data) => {
    var restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    this.setState({ DataisLoaded: false });
    axios
      .post(endpoints.catupdateSorting, {
        data,
        page,
        per_page,
        restro_id,
      })
      .then((response) => {
        // Assuming that response.data.data contains the updated items
        const updatedItems = getItems(response.data.data);

        //  console.log(updatedItems)

        this.setState({
          items: updatedItems,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error updating dish order:", error);
        // Handle error, show error message, etc.
        this.setState({ DataisLoaded: true });
      });
  };

  removeContactHandler = async (id) => {
    try {
      await axios.post(endpoints.deleteCategory, { id });
      // Filter out the deleted item
      const newContactList = this.state.items.filter(
        (contact) => contact.id !== id
      );
      // Update the state with the new list using this.setState
      this.setState({ items: newContactList });

      // Show a success toast
      toast.success("Category deleted successfully!");
    } catch (error) {
      // Handle errors if necessary
      console.error("Error deleting contact:", error);
      // Show an error toast
      toast.error("Error deleting item");
    }
  };

  submit = async (id) => {
    confirmAlert({
      title: "DELETE",
      message: "Are you sure you want to Delete it?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            // Call the removeContactHandler function
            await this.removeContactHandler(id);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  render() {
    const { status, name } = this.state;


    const columnss = [
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "actions",
        header: "Action",
      },
    ];

    const datas = this.state.items.map((item) => ({
      name: item.name,
      id: item.id,

      status: (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={item.id + "check"}
            checked={item.status === "1"}
            onChange={() => sub(item.id, item.status)}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check"}
          ></label>
          <ToastContainer />
        </div>
      ),
      actions: (
        <div className="d-flex justify-content-start align-items-center">
          <Link to={`/dashboard/editrestcategory/${item.id}`} className="mx-2">
            <EditIcon />
          </Link>

          <span
            className="trash alternate outline icon"
            style={{
              color: "red",
              marginTop: "7px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => this.submit(item.id)}
          >
            <ToastContainer />

            <DeleteIcon />
          </span>
          <Link to={`/dashboard/subcategoryrest/${item.id}`} className="mx-2">
            <Button variant="contained">Sub Category</Button>
          </Link>
          <Link to={`/dashboard/dishrestdetail/${item.id}`} className="mx-2">
            <Button variant="contained" style={{ background: "#fbaa1a" }}>
              <img
                src="https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/dish/icon/dishicon1.png"
                width={30}
                alt=""
                srcset=""
              />
              &nbsp;&nbsp;Dish
            </Button>
          </Link>
        </div>
      ),
    }));
    const { DataisLoaded } = this.state;

    const sub = (id, old_status) => {
      let newStatus = old_status === "1" ? "0" : "1";

      axios
        .post(endpoints.updateCatStatus, {
          id,
          status: newStatus,
        })
        .then((response) => {
          this.setState((prevState) => ({
            DataisLoaded: true,

            items: prevState.items.map((item) =>
              item.id === id ? { ...item, status: newStatus } : item
            ),
          }));
          // Display toaster notification for status change
          toast.success(
            `Category Status ${newStatus === "1" ? "Active" : "Inactive"}`
          );
        })
        .catch((error) => {
          console.error("Error updating status:", error);

          // Display error toaster notification
          toast.error("Error updating Category status");
        });
    };

    const onSubmit = async (e) => {
      // this.filterfetch(e)
      console.log(e);
    };


    const setCurrentPage = (id) => {
      this.setState({ currentPage: id }, () => {
        this.fetchData();
      });
    };

    const onSelectChange = (per_page) => {
      this.state.per_page = per_page;
      this.fetchData();
    };
    return (
      <div className="App">
        <div className="col col-2">
          <label>Row Per Page </label>
          <select
            name="type"
            className="form-control"
            onChange={(e) => onSelectChange(e.target.value)}
            value={this.state.per_page}
          >

            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <PageTitle
          title="Category List"
          linkid={this.props.match.params.restro_id}
          linkurl="/dashboard/addrestcategory"
          linkTitle="Add Category"
        />
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <Input

                  id="name"

                  type="text"
                  name="name"
                  value={name}
                  place="Search Category Name"
                  requiredInput="required"

                  onChange={this.onNameChange}


                />
              </div>

              <div className="col-md-2 mt-4">
                <select
                  name="status"
                  value={status}
                  onChange={this.onStatusChange}
                  required
                  className="form-control"
                  style={{ marginTop: "2px" }}
                >
                  <option value="" disabled>Status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div className="col-md-3 mt-4">
                <Button
                  style={{ marginTop: "2px" }}
                  variant="contained"
                  color="primary"
                  onClick={this.handleResetFilters}
                >
                  Reset Filters
                </Button>
              </div>

            </div>
          </form>
        </Card>

        <MantineReactTable
          autoResetPageIndex={false}
          columns={columnss}
          data={datas}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableSorting={false}
          enableGlobalFilter={false}
          enableRowOrdering
          enableBottomToolbar={false}
          enablePagination={false}
          mantineRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                const newData = [...datas];
                const draggedItemId = draggingRow.original.id;

                newData.splice(
                  hoveredRow.index,
                  0,
                  // newData.splice(draggingRow.index, 1)[0]
                  {
                    ...newData.splice(draggingRow.index, 1)[0],
                    id: draggedItemId,
                  }
                );
                const idIndexMap = {};
                newData.forEach((item, index) => {
                  idIndexMap[item.id] = index;
                });

                this.setState({ items: newData });
                this.move(idIndexMap);
              }
            },
            style: { cursor: "grab" },
          })}
        />

        {!DataisLoaded && (
          <div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
          </div>
        )}

        <Pagination
          {...bootstrap5PaginationPreset}
          current={this.state.currentPage}
          total={this.state.totalPages}
          onPageChange={(e) => setCurrentPage(e)}
        />
      </div>
    );
  }
}

export default withRouter(RestCategoryDetail);
